/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialsControllerCreateMutationRequest, TrialsControllerCreateMutationResponse, TrialsControllerCreate400, TrialsControllerCreate401, TrialsControllerCreate403, TrialsControllerCreate404 } from "../../models/trialsController/TrialsControllerCreate";

function getTrialsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/trials` as const }  
  return res
}

/**
 * @summary Provision a new trial
 * {@link /api/v1/trials}
 */
export async function trialsControllerCreate(data?: TrialsControllerCreateMutationRequest, config: Partial<RequestConfig<TrialsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TrialsControllerCreateMutationResponse, ResponseErrorConfig<TrialsControllerCreate400 | TrialsControllerCreate401 | TrialsControllerCreate403 | TrialsControllerCreate404>, TrialsControllerCreateMutationRequest>({ method : "POST", url : getTrialsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}